var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"auto"},on:{"contextmenu":_vm.blockContextMenu}},[_c('iframe',{ref:"pdfViewer",staticClass:"iframePdf",attrs:{"src":_vm.pdfSrc},on:{"mouseover":_vm.blockHoverEvent}})])
}
var staticRenderFns = []

export { render, staticRenderFns }